/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react/require-default-props */

import React from 'react';
import Model from '@tripian/model';
import { StepCard, StepCardUserReaction } from '@tripian/react';

import config from '../../config';

interface IDefaultStepCard {
  step: Model.Step;
  clicked: (step: Model.Step) => void;
  alternativePois: Model.Poi[];
  alternativePoisDays: number[][];
  alternativePoiCardClicked: (alternativePoi: Model.Poi) => void;
  alternativeReplace: (alternativePoi: Model.Poi) => void;
  showAlternativesChange: (stepId: number, show: boolean) => void;
  showAlternatives?: boolean;
  // user reaction
  thumbs?: number;
  thumbsLoading?: boolean;
  thumbsClicked?: (like: number) => void;
  userReactionUndo?: () => void;
  userReactionRemoveStep?: () => void;
  // userReactionComment?: (comment: Model.REACTION_COMMENT) => void;
}

const DefaultStepCard: React.FC<IDefaultStepCard> = ({
  step,
  clicked,
  alternativePois,
  alternativePoisDays,
  alternativePoiCardClicked,
  alternativeReplace,
  showAlternativesChange,
  showAlternatives,
  // user reaction
  thumbs = -1,
  thumbsLoading,
  thumbsClicked = (like: number) => {
    // eslint-disable-next-line no-console
    console.warn('StepCardUserReaction with undefined thumbsClicked', like);
  },
  userReactionUndo = () => {
    // eslint-disable-next-line no-console
    console.warn('StepCardUserReaction with undefined userReactionUndo');
  },
  userReactionRemoveStep = () => {
    // eslint-disable-next-line no-console
    console.warn('StepCardUserReaction with undefined userReactionRemoveStep');
  },
  // userReactionComment = (comment: Model.REACTION_COMMENT) => {
  //   console.log('StepCardUserReaction with undefined userReactionComment', comment);
  // },
}) => {
  if (config.STEP_CARD_THUMBS)
    return (
      <StepCardUserReaction
        key={step.id}
        step={step}
        clicked={clicked}
        alternativePois={alternativePois}
        alternativePoisDays={alternativePoisDays}
        showAlternatives={showAlternatives}
        showAlternativesChange={showAlternativesChange}
        alternativePoiCardClicked={alternativePoiCardClicked}
        alternativeReplace={alternativeReplace}
        thumbs={thumbs}
        thumbsLoading={thumbsLoading || false}
        thumbsClicked={thumbsClicked}
        userReactionUndo={userReactionUndo}
        userReactionRemoveStep={userReactionRemoveStep}
        // userReactionComment={userReactionComment}
      />
    );

  return (
    <StepCard
      key={step.id}
      step={step}
      clicked={clicked}
      alternativePois={alternativePois}
      alternativePoisDays={alternativePoisDays}
      showAlternatives={showAlternatives}
      showAlternativesChange={showAlternativesChange}
      alternativePoiCardClicked={alternativePoiCardClicked}
      alternativeReplace={alternativeReplace}
    />
  );
};

export default DefaultStepCard;
